import { Component, createRef } from "react";

export type CaptionsProp = {
  lang: string;
  isDefault?: boolean;
  src: string;
};

export interface TrackProps {
  isDefault?: boolean;
  kind?: string;
  src: string;
  srcLang?: string;
  onCueChange?: (text: string) => void;
  onLoad?: (e: Event) => void;
}

export class Track extends Component<TrackProps> {
  ref = createRef<HTMLTrackElement>();

  componentDidMount() {
    if (this.ref.current) {
      // Load src after render to force loading file
      this.ref.current.src = this.props.src;

      this.ref.current.addEventListener("cuechange", this.handleCueChange);
      this.ref.current.addEventListener("load", this.handleLoad);
    }
  }

  componentWillUnmount() {
    if (this.ref.current) {
      this.ref.current.removeEventListener("cuechange", this.handleCueChange);
      this.ref.current.removeEventListener("load", this.handleLoad);
    }
  }

  handleCueChange = (e: Event) => {
    // Bubble cue text to external handler.
    const { onCueChange } = this.props;
    const VOICE_REGEX = /<\/?v[^>]*>/g;
    const currentCue = (e.target as HTMLTrackElement)?.track.activeCues?.[0];
    const text: string = (currentCue as VTTCue)?.text || "";
    onCueChange?.(text.replace(VOICE_REGEX, ""));
  };

  handleLoad = (e: Event) => {
    this.props.onLoad?.(e);
  };

  render() {
    const { isDefault, kind, srcLang = "en" } = this.props;

    return (
      <track
        ref={this.ref}
        default={isDefault}
        kind={kind ?? "captions"}
        srcLang={srcLang}
        label="trackComponent" // Used to differentiate between <Track> elements and tracks baked into video file.
      />
    );
  }
}
